import './EpisodeListInfo.scss'

import React, { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import EpisodeSubInfo from './EpisodeSubInfo'

import useRouter from '../hooks/useRouter'
import { toLocaleUrl } from '../utils/locale'
import { safeMapLoop } from '../utils/misc'

import { ReleaseStatus, SearchQueryType } from '../constants/enums'

interface Props {
  className?: string
  isSeries: boolean
  releaseStatus: ReleaseStatus | undefined
  latestEpisodeTitle?: string
  episodeTotal: number
  produceYear: number | null
  produceCountries: string[]
}

export default function EpisodeListInfo({
  className,
  isSeries,
  releaseStatus,
  latestEpisodeTitle,
  episodeTotal,
  produceYear,
  produceCountries,
}: Props) {
  const { t } = useTranslation()
  const { history } = useRouter()

  const handleClick = (e: MouseEvent<HTMLSpanElement>, queryKind: SearchQueryType, queryParameter: string | number) => {
    e.preventDefault()
    e.stopPropagation()
    history.push(toLocaleUrl(`/search?${queryKind}=${queryParameter}`))
  }

  return (
    <div className={classNames('EpisodeListInfo', className)}>
      {isSeries ? (
        <EpisodeSubInfo
          latestEpisodeTitle={latestEpisodeTitle}
          episodeTotal={episodeTotal}
          releaseStatus={releaseStatus}
        />
      ) : (
        <>
          {produceYear && (
            <>
              <span
                className="EpisodeListInfo__nonSeries"
                onClick={e => handleClick(e, SearchQueryType.PRODUCE_YEAR, produceYear)}
              >
                {produceYear}
              </span>
            </>
          )}
          {safeMapLoop(produceCountries, country => (
            <span
              key={country}
              className="EpisodeListInfo__nonSeries"
              onClick={e => handleClick(e, SearchQueryType.PRODUCE_COUNTRY, country)}
            >
              {t(country)}
            </span>
          ))}
        </>
      )}
    </div>
  )
}
